import { Link } from 'react-router-dom';
import { ISSUER } from '@/lib/book';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900">
      <div className="mx-auto flex w-full flex-col gap-6 px-4 py-10 md:flex-row md:items-start md:justify-between md:px-10 md:py-12">
        <div className="max-w-md">
          <p className="font-heading text-xl font-bold text-background-50">봉사의 길</p>
          <p className="mt-1 font-label text-sm text-accent-300">세창 박종윤 사진 자서전</p>
          <p className="mt-4 text-sm leading-relaxed text-primary-100">
            1969년 뉴대전로타리클럽 창립회원으로 시작한 반세기 봉사의 기록.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <p className="font-label text-sm font-medium text-accent-300">바로가기</p>
          <Link to="/" className="text-sm text-primary-100 transition-colors hover:text-background-50">
            표지
          </Link>
          <Link to="/read?page=1" className="text-sm text-primary-100 transition-colors hover:text-background-50">
            책 읽기
          </Link>
          <Link to="/about" className="text-sm text-primary-100 transition-colors hover:text-background-50">
            소개
          </Link>
        </div>
      </div>

      <div className="border-t border-primary-800/60">
        <div className="mx-auto flex w-full flex-col gap-2 px-4 py-5 text-xs text-primary-200 sm:flex-row sm:items-center sm:justify-between md:px-10">
          <p>© 2026 뉴대전로타리클럽 · 국제로타리 3680지구</p>
          <p>발행 · {ISSUER}</p>
        </div>
      </div>
    </footer>
  );
}